import { pickBy } from 'lodash'
import type { Schema } from '@wix/wix-data-schema-types'
import { isPagelinkField } from '@wix/wix-data-client-common'

export const formatFields = ({
  rawFields,
  isFromExistingCollection,
}: {
  rawFields: Schema['fields']
  isFromExistingCollection: boolean
}) => {
  const fields = isFromExistingCollection
    ? rawFields
    : pickBy(rawFields, field => !isPagelinkField(field))

  return {
    ...pickBy(fields, field => !field.systemField),
    ...pickBy(fields, field => field.systemField),
  }
}
